module.exports = __webpack_public_path__ + "images/dark-luxury-ddf06cc71fc36a03873800a90e069eb7.jpg";